/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import ActionModel, { ExitType } from 'cio/models/action';
import CampaignModel from 'cio/models/campaign';
import SubjectStepModel from 'cio/models/subject-step';
import { inject as service } from '@ember/service';
import MomentService from 'cio/services/moment';

type SubjectStepDescriptionContentConditionalWaitActionArgs = {
  step: SubjectStepModel;
};

export default class SubjectStepDescriptionContentConditionalWaitAction extends Component<SubjectStepDescriptionContentConditionalWaitActionArgs> {
  @service moment!: MomentService;

  get actionModel(): ActionModel | null {
    return this.args.step.belongsTo('action').value() as ActionModel | null;
  }

  get campaignModel(): CampaignModel | null {
    let action = this.actionModel;

    if (action == null) {
      return null;
    }

    return action.belongsTo('campaign').value() as CampaignModel | null;
  }

  get isDueDateInPast() {
    let { step } = this.args;

    return step.due < this.moment.currentTimestamp || step.due < step.entered;
  }

  get willSkip() {
    let { step } = this.args;

    return step.future && step.due != null && this.isDueDateInPast;
  }

  get verb() {
    let { step } = this.args;

    if (this.willSkip) {
      return 'skip';
    }

    if (step.current) {
      return 'waiting';
    } else if (!step.future) {
      return 'waited';
    }

    return 'wait';
  }

  get hasConditions() {
    return (this.actionModel?.multiConditions?.length ?? 0) > 0 ?? false;
  }

  get hasEventDelayCondition() {
    return !isEmpty(this.actionModel?.delayEventAttr);
  }

  get hasMaximumWait() {
    return this.actionModel?.exitType !== ExitType.Never;
  }

  get hasAnyWaitConditions() {
    return this.hasConditions || this.hasEventDelayCondition || this.hasMaximumWait;
  }
}
